class FavouritesManager {
  get activeFavourites() {
    try {
      return JSON.parse(localStorage.getItem('activeFavourites') || '') || {}
    } catch (e) {
      return {}
    }
  }

  set activeFavourites(updated) {
    const serialized = JSON.stringify(updated)
    localStorage.setItem('activeFavourites', serialized)
  }

  get activeSettings() {
    try {
      return JSON.parse(localStorage.getItem('activeListSettings') || '') || {}
    } catch (e) {
      return {}
    }
  }

  set activeSettings(updated) {
    const serialized = JSON.stringify(updated)
    localStorage.setItem('activeListSettings', serialized)
  }

  setFavouriteId(key: string, id: number) {
    const current = { ...this.activeFavourites }
    current[key] = id
    this.activeFavourites = current
  }

  unsetFavouriteId(key: string) {
    const current = { ...this.activeFavourites }
    delete current[key]
    this.activeFavourites = current
  }

  setSetting(key: string, settings: any) {
    const current = { ...this.activeSettings }
    current[key] = { ...settings }
    this.activeSettings = current
  }

  unsetSetting(key: string) {
    const current = { ...this.activeSettings }
    delete current[key]
    this.activeSettings = current
  }

  checkFavoriteId(key: string) {
    return this.activeFavourites[key]
  }

  checkSetting(key: string) {
    return this.activeSettings[key]
  }
}

export default new FavouritesManager()
